import React, {useContext, useEffect, useState} from "react";
import { Navigate, useLocation, NavigateProps, To } from "react-router"; // TODO: do we use our own version?
import { useUpdateSearchParams } from "./Link";

const LocationContext = React.createContext({
    // Here, do not update. Usually who ever uses this function is going to update it (navigate, Link etc.)
    getLastMatchingPath: (path: string) => ({path, index: 0} as {path: string, index: number}),
    portfolioLink: (prefix: string, fallback: string) => fallback as To,
})

export function LocationProvider({children}) {
    const [history, setHistory] = useState(["/"])
    const location = useLocation()

    useEffect(() => {
        const fullPath = location.pathname + (location.search ? location.search : '')
        // Don't add path if it looks like it is in a modal
        if (!fullPath.endsWith('/edit') && !fullPath.endsWith('/add'))
            setHistory(ls => [fullPath, ...ls].slice(0, 30)) // forget the history after a while
    }, [location])
    //console.log(history)

    // Here, do not update. Usually who ever uses this function is going to update it (navigate, Link etc.)
    const getLastMatchingPath = (path: string) => {
        const index = history.findIndex(p => p.startsWith(path))
        return {path: history[index] ?? path, index}
    }

    function portfolioLink(prefix: string, fallback: string) {
        if (location.pathname.startsWith(prefix))
            return getLastMatchingPath(prefix + "?")?.path ?? fallback // '?' is for pagination
        else
            return getLastMatchingPath(prefix)?.path ?? fallback
    }

    return (
        <LocationContext.Provider value={{getLastMatchingPath, portfolioLink}}>
            {children}
        </LocationContext.Provider>
    )
}

export function useLocationHistory() {
    return useContext(LocationContext)
}

export function HistoryNavigate({prefix, fallback}) {
    const {getLastMatchingPath} = useLocationHistory()
    const {path, index} = getLastMatchingPath(prefix) ?? fallback
    const to = (path === prefix || index === 0) ? fallback : path
    //console.log(to)
    return <FilterNavigate to={to} replace />
}

export function FilterNavigate(props: NavigateProps) {
    const update = useUpdateSearchParams()
    const to = update(props.to)
    return <Navigate {...{...props, to}} />
}